function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_488",
  "data-name": "Rechteck 488",
  width: 58.734,
  height: 63.252,
  fill: "none",
  stroke: "#009fe3",
  strokeWidth: 2
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_1660",
  "data-name": "Gruppe 1660",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_330",
  "data-name": "Ellipse 330",
  cx: 5.648,
  cy: 5.648,
  r: 5.648,
  transform: "translate(23.72 35.015)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_331",
  "data-name": "Ellipse 331",
  cx: 5.648,
  cy: 5.648,
  r: 5.648,
  transform: "translate(39.533 28.238)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1334",
  "data-name": "Pfad 1334",
  d: "M39.849,56.554V48.515a4.519,4.519,0,0,0-3.089-4.286L33.072,43l-5.648,5.648L21.777,43l-3.688,1.229A4.519,4.519,0,0,0,15,48.515v8.039",
  transform: "translate(1.943 5.569)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1335",
  "data-name": "Pfad 1335",
  d: "M53.072,50.554V42.515a4.519,4.519,0,0,0-3.089-4.286L46.3,37l-5.648,5.648L35,37",
  transform: "translate(4.533 4.792)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_37",
  "data-name": "Linie 37",
  x1: 50.719,
  transform: "translate(4.008 16.943)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_38",
  "data-name": "Linie 38",
  y2: 29.367,
  transform: "translate(29.367 1.13)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1336",
  "data-name": "Pfad 1336",
  d: "M43.389,23.59C41.911,10.7,35.494,1,27.789,1s-14.122,9.7-15.6,22.59",
  transform: "translate(1.579 0.13)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_39",
  "data-name": "Linie 39",
  y2: 6.777,
  transform: "translate(21.461 55.346)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_40",
  "data-name": "Linie 40",
  y2: 6.777,
  transform: "translate(37.274 55.346)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_41",
  "data-name": "Linie 41",
  y2: 6.777,
  transform: "translate(53.087 48.569)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_332",
  "data-name": "Ellipse 332",
  cx: 5.648,
  cy: 5.648,
  r: 5.648,
  transform: "translate(7.907 28.238)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1337",
  "data-name": "Pfad 1337",
  d: "M1,50.554V42.515a4.519,4.519,0,0,1,3.089-4.286L7.777,37l5.648,5.648L19.072,37",
  transform: "translate(0.13 4.792)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_42",
  "data-name": "Linie 42",
  y2: 6.777,
  transform: "translate(5.648 48.569)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1338",
  "data-name": "Pfad 1338",
  d: "M55.961,38.274A28.225,28.225,0,1,0,1,29.238a28.084,28.084,0,0,0,1.515,9.036",
  transform: "translate(0.13 0.13)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgPersona2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.734,
    height: 63.252,
    viewBox: "0 0 58.734 63.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3631",
    "data-name": "Gruppe 3631",
    style: {
      isolation: "isolate"
    }
  }, _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona2);
export default __webpack_public_path__ + "static/media/persona2.d32dd167.svg";
export { ForwardRef as ReactComponent };